import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { FedExCupPlayer } from '../../api/models';

export type TABLE_TYPE = Table<FedExCupPlayer>;

export const TABLE = 'fedExCupPlayer';
const SCHEMA = 'fedexCupId';

class FedExCupPlayerDatabase implements DataRepository<FedExCupPlayer> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<FedExCupPlayer | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: FedExCupPlayer, key: Key): Promise<FedExCupPlayer> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: FedExCupPlayer[]): Promise<FedExCupPlayer[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<FedExCupPlayer[]> {
    return this.db[TABLE].toArray();
  }
}

export const FedExCupPlayerDB = new FedExCupPlayerDatabase(db);
